import { useTranslate } from '@/hooks'
import { useAppSelector } from '@/redux/hooks'

export const TermsAndConditions: React.FC = () => {
  const { translate } = useTranslate()

  const settings = useAppSelector(
    (store) => store.settingsApi.settings.response
  )

  const eCommerceName = settings.name
  const returnsPolicyUrl = settings.external_return_policy_url

  const isMisako = settings.ecommerce_group == 'misako'
  const isHoff = settings.ecommerce_group == 'hoff'

  if (isHoff) {
    return (
      <div className="mt-3 space-y-2 text-center">
        <p className="text-xs font-normal text-grey-1">
          {translate('landing_user_politics1') + ' '}
          <a
            className="underline underline-offset-2"
            href="https://itsrever.com/user-terms/"
            target="_blank"
            rel="noreferrer"
            dangerouslySetInnerHTML={{
              __html: translate('landing_user_politics2')
            }}
          />
          {' ' + translate('landing_user_politics3') + ' '}
          <a
            className="underline underline-offset-2"
            href="https://itsrever.com/privacy-policy/"
            target="_blank"
            rel="noreferrer"
            dangerouslySetInnerHTML={{
              __html: translate('landing_user_politics4')
            }}
          />
        </p>
      </div>
    )
  }

  if (isMisako) {
    return (
      <div className="mt-2 space-y-2 text-center">
        {returnsPolicyUrl ? (
          <a
            className="text-xs font-light tracking-wide text-grey-1 underline underline-offset-8"
            href={returnsPolicyUrl}
            target="_blank"
            rel="noreferrer"
            dangerouslySetInnerHTML={{
              __html: translate('landing_returns_policy')
            }}
          />
        ) : null}
      </div>
    )
  }

  return (
    <div className="mt-3 space-y-2 text-center [text-wrap:pretty]">
      {returnsPolicyUrl ? (
        <a
          className="text-sm font-normal text-grey-1 underline underline-offset-4"
          href={returnsPolicyUrl}
          target="_blank"
          rel="noreferrer"
          dangerouslySetInnerHTML={{
            __html: translate('landing_returns_policy') + (eCommerceName ?? '')
          }}
        />
      ) : null}
      <p className="text-xs font-normal text-grey-1">
        {translate('landing_user_politics1') + ' '}
        <a
          className="underline underline-offset-4"
          href="https://itsrever.com/user-terms/"
          target="_blank"
          rel="noreferrer"
          dangerouslySetInnerHTML={{
            __html: translate('landing_user_politics2')
          }}
        />
        {' ' + translate('landing_user_politics3') + ' '}
        <a
          className="underline underline-offset-4"
          href="https://itsrever.com/privacy-policy/"
          target="_blank"
          rel="noreferrer"
          dangerouslySetInnerHTML={{
            __html: translate('landing_user_politics4')
          }}
        />
      </p>
    </div>
  )
}
